// ContactForm.jsx
import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './ContactComponent.css';


const ContactComponent = () => {
  
  const refForm = useRef();

  const [isMessageSent, setIsMessageSent] = useState(false);

  const handleSubmit = (e) => {

    e.preventDefault();

    const serviceId = process.env.REACT_APP_SERVICE;
    const templateId = process.env.REACT_APP_TEMPLATE_ID;
    const apiKey = process.env.REACT_APP_PRIVATE_API;
    const apiPublic = process.env.REACT_APP_PUBLIC_API;

    emailjs.sendForm(serviceId, templateId, refForm.current, apiKey, apiPublic)
      .then(result => console.log(result.text))
        // Resetear el formulario después de enviarlo
        .catch(error => console.log(error))
        refForm.current.reset();
        setIsMessageSent(true);
        setTimeout(() => {
          setIsMessageSent(false);
        }, 5000);
      };

  return (
    
    <div id='contact'>
      <div className="section__header">
        <span className="section__eyebrow">&lt;Contact /&gt;</span>
        <h2 className="section__title">Contact Me</h2>
      </div>
      <div className='contact__box'>
        <form ref={refForm} action='' onSubmit={handleSubmit}>
            <div className="contact__row">
                <label>
                    Name
                    <input
                    type="text"
                    placeholder='Ej: Jhon Dae'
                    required
                    name="username"
                    />
                </label>

                <label>
                    Email
                    <input
                    type="email"
                    placeholder='you@email.com'
                    required
                    name="email"
                    id='email'
                    />
                </label>
            </div>

            <label>
                Message
                <textarea
                maxLength="500"
                placeholder='Type your message'
                required
                name="message"
                cols="30"
                />
            </label>
            <button type="submit" className="contact__submit">Send
               <i className="fi fi-sr-envelope"></i>
            </button>
        </form>
        {isMessageSent && (
          <div className="confirmation-message">
            Message sent successfully! Thank you.
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactComponent;
